import {
  WSActions,
  WSButton,
  WSElement,
  WSList,
  WSPanel,
  WSText
} from "@wingspanhq/fe-component-library";
import type { planEnrollmentApiSpec } from "@wingspanhq/wingspan-api-types";
import { OnboardingStep } from "../../../Onboarding/types";
import React from "react";
import { AreYouSureInfo, ContinueWithCancellationInfo } from "./PlanTypes";

type IPlanType = planEnrollmentApiSpec.PlanEnrollment["planType"];

export const StepWhatToExpect: React.FC<
  OnboardingStep & { enrollmentName: string; planType: IPlanType }
> = props => {
  const enrollmentName = props.enrollmentName;

  return (
    <WSList gap="2XL">
      <WSPanel>
        <WSList gap="L">
          <AreYouSureInfo planType={props.planType} />

          <WSButton.Secondary onClick={props.onBack}>
            Nevermind, keep my insurance
          </WSButton.Secondary>
        </WSList>
      </WSPanel>

      <WSPanel>
        <WSList gap="L">
          <ContinueWithCancellationInfo planType={props.planType} />
        </WSList>
      </WSPanel>

      <WSActions
        alignment="fill"
        buttons={[
          {
            kind: "Secondary",
            label: "Nevermind, keep my insurance",
            onClick: props.onBack,
            type: "button"
          },
          {
            label: "Continue",
            type: "submit",
            onClick: props.onNext
          }
        ]}
      />
    </WSList>
  );
};
